import {updateModelValueEmit} from './currency-price';

function initEditableInputComponent(app) {
    app.component('editableInput',
        {
            template: '#editable-input',
            inheritAttrs: false,
            props: {
                editOkLabel: {required: false},
                editCancelLabel: {required: false},
                editLabel: {required: false},
                showIcons: {default: true},
                modelValue: {required: true},
                inputClass: {required: false},
                isSubmittable: {default: false},
                submitAction: {default: ''},
                inputType: {default: 'text'},
                isRequired: {default: false},
                hasCancel: {default: true},
                onSave: {},
                forceTextMode: {
                    required: false,
                    type: Boolean,
                    default: false,
                },
                haveAdditionalBorderButton: {
                    required: false,
                    type: Boolean,
                    default: false,
                },
            },
            emits: [updateModelValueEmit, 'start-edit', 'cancel', 'save-edit'],
            data() {
                return {
                    isEditMode: false,
                    initialValue: this.modelValue,
                    newValue: this.modelValue,
                    isTextMode: this.forceTextMode,
                };
            },
            computed: {
                classObject() {
                    return {
                        'input-group_borderless': this.forceTextMode,
                        'input-group_text-inline': this.forceTextMode,
                    };
                },
            },
            watch: {
                newValue(val) {
                    this.$emit(updateModelValueEmit, val);
                },
            },
            methods: {
                startEdit() {
                    this.isEditMode = !this.isEditMode;
                    this.$emit('start-edit');

                    this.$nextTick(() => {
                        if (this.$refs.editInput) {
                            this.$refs.editInput.focus();
                        }
                    });
                },
                saveEdit() {
                    this.isEditMode = false;
                    this.$emit('save-edit');
                    if (this.onSave) {
                        this.onSave();
                    }
                },
                cancelEdit() {
                    this.$emit(updateModelValueEmit, this.initialValue);
                    this.newValue = this.initialValue;
                    this.isEditMode = !this.isEditMode;
                    this.$emit('cancel', this.initialValue);
                },
            },
        });
}

export default initEditableInputComponent;
